import { render } from "./GuestOrderSummary.vue?vue&type=template&id=254d190c"
import script from "./GuestOrderSummary.vue?vue&type=script&lang=js"
export * from "./GuestOrderSummary.vue?vue&type=script&lang=js"

import "./GuestOrderSummary.vue?vue&type=style&index=0&id=254d190c&lang=css"

import exportComponent from "/Users/wouter/Vue-apps/BRGR/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__